module.exports = __webpack_public_path__ + "static/img/privacy-9.0c091b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-9.png
// module id = 1QxW
// module chunks = 1